module.exports = __webpack_public_path__ + "static/media/Login-LearSmith-Logo@2x.107d2c37.png";